const filterListModalFilterService = {
  filter: 'FILTROS',
  clear: 'borrar todos los filtros'
};

export default filterListModalFilterService;
